import { apiService } from 'services'

import { TokenResponse } from 'types'

const getTokenInDev = async (userId: number) => {
  return apiService.post<TokenResponse>(`/auth/tg_dev?tgId=${userId}`)
}

const getToken = async (initData: string) => {
  const formData = new FormData()
  formData.append('initData', initData)

  return apiService.post<TokenResponse>('/auth/tg', formData, {
    headers: {
      accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const AuthApi = { getToken, getTokenInDev }
